import easyRbac from 'easy-rbac';
import rules from 'rules';

export const RBAC = easyRbac.create(rules);
